const menu = {
  key: "commissionSalesGroups",
  route: "/legacy/commission-sales-groups",
  label: "sidebar.commissionSalesGroups",
  icon: "faTable",
  group: "configuration",
  order: 10,
  permission: "legacy.commissionSalesGroups.read"
};

export default menu;